import type { DemoKey } from './keys';

export const pl: Partial<Record<DemoKey, string>> = {
  'app.eyebrow': 'Geometria · 3D',
  'panel.figure': 'Figura',
  'panel.dims': 'Wymiary',
  'panel.style': 'Wygląd',
  'panel.lines': 'Linie specjalne',
  'style.body': 'Bryła',
  'style.line': 'Linia',
  'style.cut': 'Przekrój',
  'style.labels': 'Etykiety wierzchołków',
  'group.face': 'Przekątne ścian / tworzące',
  'group.space': 'Przekątne / osie / mediany',
  'split.label': 'Przekrój',
  'btn.animate': 'Animuj',
  'btn.reset': 'Resetuj',
  'hint.line1': 'Przeciągnij aby obrócić · Przewiń aby powiększyć',
  'hint.line2': 'Kliknij linię aby wybrać',
  'fig.cuboid': 'Prostopadłościan',
  'fig.cube': 'Sześcian',
  'fig.triPrism': 'Graniastosłup trójkątny',
  'fig.hexPrism': 'Graniastosłup sześciokątny',
  'fig.tetrahedron': 'Czworościan',
  'fig.squarePyramid': 'Ostrosłup czworokątny',
  'fig.cylinder': 'Walec',
  'fig.cone': 'Stożek',
  'fig.sphere': 'Kula',
  'fig.frustumPyramid': 'Ostrosłup ścięty',
  'fig.frustumCone': 'Stożek ścięty',
  'dim.length': 'długość',
  'dim.width': 'szerokość',
  'dim.height': 'wysokość',
  'dim.side': 'bok',
  'dim.radius': 'promień',
  'dim.r1': 'promień dolny',
  'dim.r2': 'promień górny',
  'dim.sideBase': 'bok podstawy',
  'dim.sideTop': 'bok górny',
  'info.face': 'ściana',
  'info.center': 'przez środek',
  'info.diagonal': 'przekątna',
  'info.axial': 'przekątna osiowa',
  'info.diameter': 'średnica',
  'info.generator': 'tworząca',
  'info.axis': 'oś',
  'info.height': 'wysokość',
  'info.median': 'mediana',
  'info.apothem': 'apotema',
  'info.diameterBase': 'średnica podstawy',
  'info.diameterTop': 'średnica górna',
};
